// Line-level diff using classic LCS dynamic programming. Not the fastest
// (quadratic in line count), but input sizes for Edit-tool diffs are
// small enough that it doesn't matter. Produces a flat stream of
// equal / remove / add entries suitable for rendering side-by-side or
// as a unified diff.

export type DiffLine =
  | { kind: 'equal'; text: string }
  | { kind: 'remove'; text: string }
  | { kind: 'add'; text: string }

export function diffLines(before: string, after: string): DiffLine[] {
  const a = before.split('\n')
  const b = after.split('\n')
  const n = a.length
  const m = b.length

  // dp[i][j] = LCS length of a[i..] and b[j..]
  const dp: number[][] = Array.from({ length: n + 1 }, () =>
    new Array(m + 1).fill(0),
  )
  for (let i = n - 1; i >= 0; i--) {
    for (let j = m - 1; j >= 0; j--) {
      if (a[i] === b[j]) dp[i][j] = dp[i + 1][j + 1] + 1
      else dp[i][j] = Math.max(dp[i + 1][j], dp[i][j + 1])
    }
  }

  const out: DiffLine[] = []
  let i = 0
  let j = 0
  while (i < n && j < m) {
    if (a[i] === b[j]) {
      out.push({ kind: 'equal', text: a[i] })
      i++
      j++
    } else if (dp[i + 1][j] >= dp[i][j + 1]) {
      out.push({ kind: 'remove', text: a[i] })
      i++
    } else {
      out.push({ kind: 'add', text: b[j] })
      j++
    }
  }
  while (i < n) out.push({ kind: 'remove', text: a[i++] })
  while (j < m) out.push({ kind: 'add', text: b[j++] })
  return out
}
